export const resolveApiBaseUrl = () => {
    const envValue = process.env.REACT_APP_API_BASE_URL?.trim();
    if (envValue) {
        return envValue.replace(/\/$/, '');
    }

    if (typeof window === 'undefined') {
        return '';
    }

    const { protocol, hostname, port } = window.location;

    if (port && port !== '80' && port !== '443') {
        if (port === '3000' || port === '5173') {
            return `${protocol}//${hostname}:8000`;
        }

        return `${protocol}//${hostname}:${port}`;
    }

    return `${protocol}//${hostname}`;
};

export const buildApiUrl = (path) => {
    const baseUrl = resolveApiBaseUrl();
    if (!baseUrl) {
        return path;
    }

    return `${baseUrl}${path.startsWith('/') ? '' : '/'}${path}`;
};

export const buildGithubAssetUrl = (repo, src) => {
    if (!src) {
        return src;
    }

    try {
        const url = new URL(src);
        return url.href;
    } catch (error) {
        // Not an absolute URL, fall back to raw GitHub asset path
    }

    if (!repo) {
        return src;
    }

    const owner = process.env.REACT_APP_GITHUB_OWNER || 'prathameshlakawade';
    const cleanedSrc = src.replace(/^\.\//, '');

    return `https://raw.githubusercontent.com/${owner}/${repo}/main/${cleanedSrc}`;
};
